import { takeLeading } from 'redux-saga/effects';
import actions from './actions';

const {
  Types: { GET_GEO_LOCATION_REQUEST },
  Creators,
} = actions;

export async function getGeolocation() {
  return new Promise(async (resolve, reject) => {
    if ('geolocation' in navigator) {
      try {
        const position = await new Promise((innerResolve, innerReject) => {
          navigator.geolocation.getCurrentPosition(innerResolve, innerReject);
        });
        resolve(position.coords);
      } catch (error) {
        resolve(null);
      }
    } else {
      resolve(null);
    }
  });
}

export function* newOlsSaga() {
  yield takeLeading(GET_GEO_LOCATION_REQUEST, getGeolocation);
}
